enum Stats {
  NumCuratedTrails = 500, // thousand
  NumUsers = 95, // million
  LoggedDistanceMeters = 3218688000000 // meters
}

export default Stats;
